import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'

import EventTypeSelector from './field/event-type-selector'
import Field from './field'
import TextInput from './field/text-input'
import ImageInput from './field/image-input'
import FieldError from './field/field-error'
import VenueSearch from './field/venue-search'
import Wysiwyg from '../wysiwyg'

import styles from './setupform-form.css'
import { CROPPER_MIN_IMAGE_WIDTH, CROPPER_MIN_IMAGE_HEIGHT } from '../../constants/cropper-tool-constants'

const SetupformForm = ({ fields }) => (
  <form styleName="form">

    <Field
      description={
        'Give your event a title that stands out. It’s often effective to run with something ' +
        'compelling and actionable, e.g. Award-Winning Jazz + Two-Course Meal.'
      }
      name="Event Name"
    >
      <TextInput data={fields.name} placeholder="An Awesome Event" />
      <FieldError data={fields.name} />
    </Field>

    <Field name="Where is your event?">
      <VenueSearch
        placeholder="Search for a venue"
        venueAddressData={fields.venueAddress}
        venueIdData={fields.venueId}
        venueNameData={fields.venueName}
      />
      <FieldError data={fields.venueId} />
    </Field>

    <Field name="What category is your event?">
      <EventTypeSelector data={fields.eventTypeId} />
      <FieldError data={fields.eventTypeId} />
    </Field>

    <Field
      description={
        `Select an image that will be displayed on the website. It must be at ` +
        `least ${CROPPER_MIN_IMAGE_WIDTH}x${CROPPER_MIN_IMAGE_HEIGHT}.`
      }
      name="Choose an image for your event"
    >
      <ImageInput data={fields.image} placeholder="Please select an image from your computer" />
      <FieldError data={fields.image} />
    </Field>

    <Field
      description="A short pithy description of your event which will be displayed alongside it when shown on YPlan"
      name="Tagline"
    >
      <TextInput data={fields.tagline} placeholder="This event is great!" />
      <FieldError data={fields.tagline} />
    </Field>

    <Field
      description={
        'Describe the event to your customers. ' +
        'Provide as much information as possible, while trying to keep it witty and concise.'
      }
      name="Description"
    >
      <Wysiwyg
        onChange={fields.description.onChange}
        value={fields.description.value}
        placeholder="An Awesome Event is your unique opportunity..."
      />
      <FieldError data={fields.description} />
    </Field>

    <Field
      description={
        'A short offer description (maximum 24 characters) ' +
        'which will appear in the Offer section on the product page.'
      }
      name="Offer Description"
    >
      <TextInput data={fields.rawOfferText} placeholder="This offer is great!" />
      <FieldError data={fields.rawOfferText} />
    </Field>

  </form>
)

SetupformForm.propTypes = {
  fields: PropTypes.object,
}

export default CSSModules(SetupformForm, styles)



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/setupform-form.js
 **/